import React, { useContext, useEffect, useState } from 'react';
import { Calendar, momentLocalizer, Views } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { Icon } from '@iconify/react';
import './cal.css';
import { FilterSearch, GetCalendarSittingsUser } from '../Services/allApi';
import language from '../language.json';
import { addcontext } from '../ContextShare/ContextShare';
import { useNavigate } from 'react-router-dom';

const localizer = momentLocalizer(moment);

const CalendarOfSittings = () => {
  const { isSearchOrAdSearch, setIsSearchOrAdSearch } = useContext(addcontext);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [calendarData, setCalendarData] = useState([]);
  const [events, setEvents] = useState([]);
  const [sessions, setSessions] = useState([

  ]);

  const { langChanged, setlangChanged } = useContext(addcontext);
  const [currentLanguage, setCurrentLanguage] = useState();

  useEffect(() => {
    setCurrentLanguage(localStorage.getItem('language') || 'en');
  }, [currentLanguage, langChanged]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await GetCalendarSittingsUser();
        if (result?.data?.data) {
          setCalendarData(result.data.data);
          const newSessions = result?.data?.session_details
          console.log(newSessions);
          setSessions(newSessions)
        }
      } catch (error) {
        console.error('Error fetching calendar data:', error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        const fetchData = async () => {
          try {
            const result = await GetCalendarSittingsUser();
            if (result?.data?.data) {
              setCalendarData(result.data.data);
              setSessions(result?.data?.session_details);
            }
          } catch (error) {
            console.error('Error fetching calendar data:', error);
          }
        };
        fetchData();
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, []);

  useEffect(() => {
    const mappedEvents = calendarData.map((event) => ({
      title: currentLanguage === 'en' ? `${event?.description}` : `${event?.malayalam_description}`,
      titleOnHover: currentLanguage === 'en' ? event?.description : event?.malayalam_description,
      start: new Date(event.sitting_date),
      end: new Date(event.sitting_date),
      allDay: true,
      pdfLink: event.pdf_link,
      pdfLink2: event.pdf_link2,
    }));

    setEvents(mappedEvents);
  }, [calendarData, currentDate, currentLanguage]);

  const isDateInAnySession = (date) => {
    return sessions.some(session =>
      moment(date).isSameOrAfter(moment(session.start), 'day') &&
      moment(date).isSameOrBefore(moment(session.end), 'day')
    );
  };

  const isOutOfCurrentMonth = (date) => {
    const startOfMonth = moment(currentDate).startOf('month');
    const endOfMonth = moment(currentDate).endOf('month');
    return !moment(date).isBetween(startOfMonth, endOfMonth, 'day', '[]');
  };

  const dayPropGetter = (date) => {
    if (isOutOfCurrentMonth(date)) {
      return {
        style: {
          backgroundColor: '#ffffff', // Make background white for out-of-month days
          color: '#ffffff',           // Hide the text (date number)
          pointerEvents: 'none',      // Prevent any interaction on these days
          border: 'none',             // Remove borders for a cleaner look
        },
      };
    }
    if (isDateInAnySession(date)) {
      return {
        style: {
          backgroundColor: '#D3D3D3', // Light blue for session dates
        },
      };
    }
    return {}; // No style for dates outside the session range
  };

  const CustomEvent = ({ event }) => {
    const { filterSearchResults, setFilterSearchResults } = useContext(addcontext);
    const { InitialSearchQuery, setInitialSearchQuery } = useContext(addcontext);
    const navigate = useNavigate();

    const handleWatchVideo = (e) => {
      const date = e?.start;
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const newDate = `${year}-${month}-${day}`;

      searchsubmitapi(newDate);
    };

    const searchsubmitapi = async (date) => {
      try {
        setIsSearchOrAdSearch('as');
        const resultSearch = await FilterSearch({ start_date: date, end_date: date }, 0, 10);
        setInitialSearchQuery({ start_date: date, end_date: date });
        setFilterSearchResults(resultSearch.data);
        navigate('/results');
      } catch (err) {
        console.log(err);
      }
    };

    return (
      <div title={event.titleOnHover} className={`flex flex-col ${event?.title?.length > 25 && 'overflow-x-scroll'}`}>
        {/* <span className='h-full text-xs'>{event.title}</span> */}
        <a
          href={event.pdfLink}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-200 hover:text-blue-400 underline h-full md:text-sm text-[9px]"
        >
          {language.View_pdf[currentLanguage]}
        </a>
        <a
          href={event.pdfLink2}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-200 hover:text-blue-400 underline h-full md:text-sm text-[9px]"
        >
          {language.List_of_proceedings[currentLanguage]}
        </a>
        <a
          onClick={() => handleWatchVideo(event)}
          className="text-blue-200 hover:text-blue-400 underline h-full md:text-sm text-[9px]"
        >
          {language.Watch_video[currentLanguage]}
        </a>
      </div>
    );
  };

  const handlePrevYear = () => {
    const newDate = new Date(currentDate);
    newDate.setFullYear(newDate.getFullYear() - 1);
    setCurrentDate(newDate);
  };

  const handleNextYear = () => {
    const newDate = new Date(currentDate);
    newDate.setFullYear(newDate.getFullYear() + 1);
    setCurrentDate(newDate);
  };

  return (
    <div className="p-2 md:max-w-7xl w-full mx-auto bg-white shadow-lg rounded-lg">
      <div className='flex justify-center w-full'>
        <h1 className="flex py-5 font-bold text-4xl mb-4 md:mb-0 lg:justify-start justify-center" style={{ color: '#001F33' }}>
          {language.calendarfSittings[currentLanguage]}
        </h1>
      </div>

      <div className="flex justify-between items-center mb-6">
        <button
          onClick={handlePrevYear}
          className="px-4 py-2 border-gray-400 border rounded flex flex-row items-center gap-2 hover:bg-gray-200 transition duration-300"
        >
          <Icon icon="ion:caret-back-sharp" />
          <span>Previous Year</span>
        </button>

        <button
          onClick={handleNextYear}
          className="px-4 py-2 border-gray-400 border rounded flex flex-row items-center gap-2 hover:bg-gray-200 transition duration-300"
        >
          <span>Next Year</span>
          <Icon icon="ion:caret-forward-sharp" />
        </button>
      </div>

      <Calendar
        localizer={localizer}
        events={events.filter(event =>
          moment(event.start).isBetween(moment(currentDate).startOf('month'), moment(currentDate).endOf('month'), 'day', '[]')
        )}
        startAccessor="start"
        endAccessor="end"
        style={{ height: 580 }}
        views={[Views.MONTH]}
        date={currentDate}
        onNavigate={setCurrentDate}
        dayPropGetter={dayPropGetter}
        components={{
          event: CustomEvent,
        }}
        messages={{
          next: 'Next Month',
          previous: 'Previous Month',
          today: 'Today',
        }}
      />

      <div className='flex flex-row pt-2 gap-10'>
        <div className='flex flex-row gap-2 items-center'>
          <div className='w-3 h-3' style={{ backgroundColor: '#D3D3D3' }}></div>
          <p>Session Date</p>
        </div>
        <div className='flex flex-row gap-2 items-center'>
          <div className='w-3 h-3' style={{ backgroundColor: '#276086' }}></div>
          <p>Sitting Date</p>
        </div>

        <div className='flex flex-row gap-2 items-center'>
          <div className='w-3 h-3' style={{ backgroundColor: '#EAF6FF' }}></div>
          <p>Today</p>
        </div>
      </div>
    </div>
  );
};

export default CalendarOfSittings;
